import * as Actions from "./actions";
import { REST_SERVICE_URL_ROOT, CLIENT_ID, CLIENT_SECRET } from '../../../../config/settings';
import { updateUsername } from "../../Login/state/actions";
import ApiService from "../../../../utils/apiService";
import * as Path from './apiRoutes';
import Axios from "axios";

const fetchDefault = (payload) => (dispatch) => {
    return ApiService.get(Path.USER_GET_LIST, payload)
        .then((response) => {
            dispatch(Actions.setList(response.data.data));
        }).catch(() => {
            dispatch(Actions.setList([]));
        })
};

const viewUser = (payload) => () => {
    return ApiService.post(Path.USER_GET_LIST, payload)
        .then((response) => {
            return response.data;
        })
};

const addUser = (payload) => () => {
    return ApiService.add(Path.USER_GET_LIST, payload)
        .then((response) => {
            return response.data;
        })
};

const editUser = (payload) => (dispatch) => {


    return ApiService.update(Path.USER_GET_LIST, payload)
        .then((response) => {
            if (response.data.data && payload.updUserCode === payload.userCode) {
                dispatch(updateUsername(payload.userName))
            }
            return response.data;
        })
};

const deleteUser = (id, updUsercode, loginId, password) => () => {
    let params = new URLSearchParams();
            params.append('username', loginId);
            params.append('password', password);
            params.append('grant_type', "password");

    Axios.post(REST_SERVICE_URL_ROOT + "/oauth/token", params, {
        headers: { 'Authorization': "Basic " + btoa(CLIENT_ID + ":" + CLIENT_SECRET) }
    }).then((response) => {
        let token = response.data.access_token
        Axios.delete(REST_SERVICE_URL_ROOT + "/logout/" + token, {
            headers: { 'Authorization': "Bearer " + token }
        })        
    })

    return ApiService.deleteByKey(Path.USER_GET_LIST, id, updUsercode)
        .then((response) => {
            return response.data;
        })
     
};

export {
    fetchDefault,
    addUser,
    editUser,
    deleteUser,
    viewUser
};
